// src/app/core/interceptors/auth-token.interceptor.ts
import { Injectable, inject } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable, from } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { environment } from 'src/environments/environment';

@Injectable()
export class AuthTokenInterceptor implements HttpInterceptor {
  private afAuth = inject(AngularFireAuth);

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!req.url.startsWith(environment.apiBase)) return next.handle(req);
  
    return this.afAuth.authState.pipe(
      take(1),
      switchMap(user => {
        if (!user) return next.handle(req);
        // Firebase already refreshes an expired token. Forcing a refresh for
        // every API read quickly exhausts the Identity Toolkit quota when a
        // clinical screen has several concurrent data sources (for example,
        // wound history behind the assessment dialog).
        return from(user.getIdToken()).pipe(
          switchMap(token => {
            const clone = req.clone({
              setHeaders: {
                Authorization: `Bearer ${token}`,
              },
            });
            return next.handle(clone);
          })
        );
      })
    );
  }

  
}
